export default __webpack_public_path__ + "resources/icons/d312-c7e5.webp";